import { Entity, ThemeSchemaResponse } from '@api';
import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { useEntity } from '@terminal/react-query-hooks/entities/useEntities';
import { queryKeys } from '@terminal/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { StepperSection } from '../components/stepper-section/StepperSection';
import styles from './AssetsOverviewTab.module.scss';
import { AssetOverviewContent } from './asset-overview-content/AssetOverviewContent';

export const AssetsOverviewTab = ({
  entity,
  theme,
}: {
  entity: Entity;
  theme: ThemeSchemaResponse;
}) => {
  const { params } = useQueryParams();
  const entityTag = params[queryKeys.entityTag];

  const { data, isLoading, isError, error } = useEntity(entityTag ?? '');

  if (isLoading) {
    return (
      <SkeletonLoader
        areas={[
          { styles: { width: '100%', height: '180px', borderRadius: '8px' } },
        ]}
      />
    );
  }

  if (isError || !data?.data) {
    throw new Error(error?.message);
  }

  return (
    <div className={styles.root}>
      <StepperSection entity={entity} theme={theme} activeIndex={1} />
      <AssetOverviewContent
        entity={entity}
        source={POSTHOG_TRACKING_SOURCES.COMPANY_TO_THEME_DRAWER}
      />
    </div>
  );
};
